<div class="container-fluid vh-100" style="background-color:#f8f8f8">
    <div class="row h-100">
        <!-- {{ 'example' | translate }} -->
        <div class="col h-100 d-flex flex-column" style="background-color:#f8f8f8">
            <div class="row align-items-center p-2 mb-4"
                style="background-color:#fff; box-shadow: 0px 10px 5px silver;">
                <!-- icono y botones de acción -->
                <div class="col-2 h-100 d-inline-flex align-items-center">
                    <img style="max-width:100%;
                    max-height:100%; height: auto;"
                        src="../../../assets/images/logo_rojo.png">
                </div>

                <div class="col-7 h-100 text-left align-middle">
                    <ng-container *ngIf="activeFacility.privileges == 1 && secondlistactive == false">

                        <!-- 
                        ** calculado - activo undo y enviar (desactivado aceptar - calcular)
                        this.buttonStatus = 1        
                        ** no calculado - activo calcular y aceptar (desactivado undo y enviar)
                        this.buttonStatus = 2 
                        -->

                        <ng-container *ngIf="buttonStatus == 0">
                            <button type="button" id="btn_acept_event"
                                class="btn sharp btn-outline-dark btn-lg d-inline-flex align-items-center"  disabled><img
                                    style="width: 24px; height:24px;" [src]="acceptEventIcon">&nbsp;{{
                                'main.buttons.accept'
                                |
                                translate }}</button>
                            &nbsp;
                            <button type="button" id="btn_undo_calc"
                                class="btn sharp btn-outline-dark btn-lg d-inline-flex align-items-center"  disabled ><img
                                    style="width: 24px; height:24px;" [src]="undoIcon">&nbsp;{{
                                'main.buttons.calc.undo' |
                                translate }}</button>
                            &nbsp;
                            <button type="button" id="btn_calc"
                                class="btn sharp btn-outline-dark btn-lg d-inline-flex align-items-center"  disabled><img
                                    style="width: 24px; height:24px;" [src]="calcIcon">&nbsp;{{
                                'main.buttons.calc.do' |
                                translate }}</button>
                            &nbsp;
                            <button type="button" id="btn_send"
                                class="btn sharp btn-outline-dark btn-lg d-inline-flex align-items-center"  disabled><img
                                    style="width: 24px; height:24px;" [src]="sendIcon">&nbsp;{{
                                'main.buttons.send'
                                |
                                translate
                                }}</button>
                        </ng-container>

                        <ng-container *ngIf="buttonStatus == 1">
                            <button type="button" id="btn_acept_event"
                                class="btn sharp btn-outline-dark btn-lg d-inline-flex align-items-center" disabled><img
                                    style="width: 24px; height:24px;" [src]="acceptEventIcon">&nbsp;{{
                                'main.buttons.accept'
                                |
                                translate }}</button>
                            &nbsp;

                            <button type="button" id="btn_undo_calc"
                                class="btn sharp btn-outline-dark btn-lg d-inline-flex align-items-center"
                                (click)="undo()" (mouseout)="undoIcon = '../../../assets/icons/icons8-arrows-64.png'"
                                (mouseover)="undoIcon = '../../../assets/icons/icons8-arrows-64-white.png'"><img
                                    style="width: 24px; height:24px;" [src]="undoIcon">&nbsp;{{
                                'main.buttons.calc.undo' |
                                translate }}</button>

                            &nbsp;

                            <button type="button" id="btn_calc"
                                class="btn sharp btn-outline-dark btn-lg d-inline-flex align-items-center" disabled><img
                                    style="width: 24px; height:24px;" [src]="calcIcon">&nbsp;{{
                                'main.buttons.calc.do' |
                                translate }}</button>

                            &nbsp;

                            <button type="button" id="btn_send"
                                class="btn sharp btn-outline-dark btn-lg d-inline-flex align-items-center"
                                (click)="send()" (mouseout)="sendIcon = '../../../assets/icons/icons8-exportar-32.png'"
                                (mouseover)="sendIcon = '../../../assets/icons/icons8-exportar-32-blanco.png'"><img
                                    style="width: 24px; height:24px;" [src]="sendIcon">&nbsp;{{
                                'main.buttons.send'
                                |
                                translate
                                }}</button>


                        </ng-container>

                        <ng-container *ngIf="buttonStatus == 2">
                            <button type="button" id="btn_acept_event"
                                class="btn sharp btn-outline-dark btn-lg d-inline-flex align-items-center"
                                (click)="accept()"
                                (mouseout)="acceptEventIcon = '../../../assets/icons/icons8_Checked_24px.png'"
                                (mouseover)="acceptEventIcon = '../../../assets/icons/icons8-comprobado-24.png'"><img
                                    style="width: 24px; height:24px;" [src]="acceptEventIcon">&nbsp;{{
                                'main.buttons.accept'
                                |
                                translate }}</button>
                            &nbsp;
                            <button type="button" id="btn_undo_calc"
                                class="btn sharp btn-outline-dark btn-lg d-inline-flex align-items-center" disabled><img
                                    style="width: 24px; height:24px;" [src]="undoIcon" >&nbsp;{{
                                'main.buttons.calc.undo' |
                                translate }}</button>
                            &nbsp;

                            <button type="button" id="btn_calc"
                                class="btn sharp btn-outline-dark btn-lg d-inline-flex align-items-center"
                                (click)="open()"
                                (mouseout)="calcIcon = '../../../assets/icons/icons8-calculadora-24.png'"
                                (mouseover)="calcIcon = '../../../assets/icons/icons8-calculadora-24-white.png'"><img
                                    style="width: 24px; height:24px;" [src]="calcIcon">&nbsp;{{
                                'main.buttons.calc.do' |
                                translate }}</button>
                            &nbsp;
                            <button type="button" id="btn_send"
                                class="btn sharp btn-outline-dark btn-lg d-inline-flex align-items-center" disabled><img
                                    style="width: 24px; height:24px;" [src]="sendIcon">&nbsp;{{
                                'main.buttons.send'
                                |
                                translate
                                }}</button>

                        </ng-container>
                    </ng-container>

                    <ng-container *ngIf="activeFacility.privileges == 0 || secondlistactive == true">
                        <button id="btn_acept_event" type="button" class="btn sharp btn-outline-dark btn-lg d-inline-flex align-items-center" id="Btn_acept_event"
                            disabled><img style="width: 24px; height:24px;" [src]="acceptEventIcon">&nbsp;{{
                            'main.buttons.accept'
                            |
                            translate }}</button>
                        &nbsp;
                        <button type="button" id="btn_undo_calc" class="btn sharp btn-outline-dark btn-lg d-inline-flex align-items-center" id="Btn_undo_calc"
                            disabled><img style="width: 24px; height:24px;" [src]="undoIcon" >&nbsp;{{
                            'main.buttons.calc.undo' |
                            translate }}</button>
                        &nbsp;
                        <button type="button" id="btn_calc" class="btn sharp btn-outline-dark btn-lg d-inline-flex align-items-center" id="Btn_calc"
                            disabled><img style="width: 24px; height:24px;" [src]="calcIcon" >&nbsp;{{
                            'main.buttons.calc.do' |
                            translate }}</button>
                        &nbsp;
                        <button type="button" id="btn_send" class="btn sharp btn-outline-dark btn-lg d-inline-flex align-items-center"
                            disabled><img style="width: 24px; height:24px;" [src]="sendIcon">&nbsp;{{
                            'main.buttons.send'
                            |
                            translate
                            }}</button>
                    </ng-container>

                </div>

                <div class="col-3 h-100 text-right">
                    <div ngbDropdown>
                        <button type="button" class="btn sharp btn-block" id="facilitydropdown"
                            style="background-color: #808080; color: #fff;" ngbDropdownToggle>
                            <img style="width: 24px; height:24px;"
                                src="../../../assets/icons/icons8-abertura-blanco-50.png">
                            &nbsp;
                            {{ 'main.facility-select' | translate}}
                        </button>
                        <div ngbDropdownMenu aria-labelledby="listdropdown" style="width: 220px;">
                            <ng-container *ngFor="let facility of facilityListUIX$ | async">
                                <button id="{{ facility.acronym}}-{{ facility.name }}"  ngbDropdownItem (click)="onFacilityChange($event, facility)">{{ facility.acronym
                                    }} - {{ facility.name }}</button>
                            </ng-container>
                        </div>
                    </div>

                </div>
            </div>

            <div class="row p-2 ml-2 mr-2 mb-3 align-items-center"
                style="background-color:#fff; box-shadow: 0px 10px 5px silver;">
                <div class="col-md-2 m-0">
                    <div class="btn-group btn-block">
                        <ng-container *ngIf="mainlistactive == true">
                            <button id="btn_main_list_selected" type="button" class="btn sharp btn-md btn-block"
                                style="background-color: #808080; color: #fff;">{{
                                'main.lists.main' | translate }}
                                <ng-container *ngIf="alertCount > 0">
                                    <span id="badge_pill_alert_count" class="badge badge-pill badge-danger">{{ alertCount }}</span>
                                </ng-container>
                            </button>
                        </ng-container>
                        <ng-container *ngIf="secondlistactive == true">
                            <button id="btn_second_list_selected" type="button" class="btn sharpbtn-md btn-block"
                                style="background-color: #808080; color: #fff;">{{
                                'main.lists.secondary' | translate }}</button>
                        </ng-container>
                        <div class="btn-group" ngbDropdown role="group" placement="bottom-right">
                            <button id="btn_dropdown_event_list_selector" class="btn sharp btn-block" style="background-color: #808080; color: #fff;"
                                ngbDropdownToggle></button>
                            <div class="dropdown-menu" ngbDropdownMenu>
                                <div class="btn-group-toggle m-1">
                                    <label id="btn_main_event_list_request" class="btn sharp btn-outline-dark btn-md btn-block text-left"
                                        style="min-width: 200px;" [ngClass]="{active: mainlistactive}">
                                        <input type="checkbox" (click)="getPrimaryList();">
                                        <img style="width: 24px; height:24px;"
                                            src="../../../assets/icons/icons8-lista-con-viñetas-48-blanco.png">&nbsp;{{
                                        'main.lists.main' | translate }}
                                        <ng-container *ngIf="alertCount > 0">
                                            <span class="badge badge-pill badge-danger">{{ alertCount }}</span>
                                        </ng-container>
                                    </label>
                                </div>

                                <div class="btn-group-toggle m-1">
                                    <label id="btn_secondary_event_list_request" class="btn sharp btn-outline-dark btn-md btn-block text-left"
                                        style="min-width: 200px;" [ngClass]="{active: secondlistactive}">
                                        <input type="checkbox" (click)="getSecondaryList();">
                                        <img style="width: 24px; height:24px;"
                                            src="../../../assets/icons/icons8-lista-con-viñetas-48-blanco.png">&nbsp;{{
                                        'main.lists.secondary' | translate }}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md m-0">
                    <form class="w-100">
                        <div class="row h-100 w-100">
                            <div class="col-2 d-inline-flex align-items-center justify-content-between">
                                <img style="width: 24px; height:24px;"
                                    src="../../../assets/icons/icons8-buscar-en-la-lista-48.png">
                                <label class="h-100 m-0 d-flex align-items-center" for="table-complete-search">
                                    <h5 class="m-0 p-0">
                                        {{ 'main.search' | translate }}
                                    </h5>
                                </label>
                            </div>
                            <div class="col-lg d-inline-flex align-items-center">
                                <input id="table-complete-search" type="text" class="form-control form-control-md"
                                    name="searchTerm" [(ngModel)]="service.searchTerm" />
                            </div>

                        </div>
                    </form>
                </div>

                <div class="col-md-2 m-0">
                    <div class="btn-toolbar d-flex flex-row-reverse" role="toolbar">
                        <div class="d-inline-block" ngbDropdown>
                            <button type="button" class="btn sharp" id="filtersdropdown" ngbDropdownToggle
                                style="background-color: #808080; color: #fff;">
                                <img style="width: 24px; height:24px;"
                                    src="../../../assets/icons/icons8-filtrar-50-blanco.png">
                            </button>
                            <div ngbDropdownMenu aria-labelledby="filtersdropdown" style="width: 220px;">
                                <div class="btn-group-toggle m-1">
                                    <label id="btn_filters_no_problem" class="btn sharp btn-outline-dark btn-sm btn-block" style="min-width: 150px;"
                                        [ngClass]="{active: noProblemFilter}">
                                        <input type="checkbox" (click)="noProblemFilterClick();">
                                        {{ 'main.filters.no-problem' | translate }}
                                    </label>
                                </div>

                                <div class="btn-group-toggle m-1">
                                    <label id="btn_filters_calc_problem" class="btn sharp btn-outline-dark btn-sm btn-block" style="min-width: 150px;"
                                        [ngClass]="{active: withProblemFilter}">
                                        <input type="checkbox" (click)="withProblemFilterClick();">
                                        {{ 'main.filters.calc-problem' | translate }}
                                    </label>
                                </div>

                                <div class="btn-group-toggle m-1">
                                    <label id="btn_filters_measurament_conflict" class="btn sharp btn-outline-dark btn-sm btn-block" style="min-width: 150px;"
                                        [ngClass]="{active: measurementConflictFilter}">
                                        <input type="checkbox" (click)="measurementConflictFilterClick();">
                                        {{ 'main.filters.measurament-conflict' | translate }}
                                    </label>
                                </div>

                                <div class="btn-group-toggle m-1">
                                    <label id="btn_filters_calculated" class="btn sharp btn-outline-dark btn-sm btn-block" style="min-width: 150px;"
                                        [ngClass]="{active: calculatedFilter}">
                                        <input type="checkbox" (click)="calculatedFilterClick();">
                                        {{ 'main.filters.calculated' | translate }}
                                    </label>
                                </div>

                                <ng-container *ngIf="secondlistactive == true">
                                    <div class="btn-group-toggle m-1">
                                        <label id="btn_filters_accepted_without_changes" class="btn sharp btn-outline-dark btn-sm btn-block" style="min-width: 150px;"
                                            [ngClass]="{active: straightAcceptedFilter}">
                                            <input type="checkbox" (click)="straightAcceptedFilterClick();">
                                            {{ 'main.filters.accepted-without-changes' | translate }}
                                        </label>
                                    </div>
    
                                    <div class="btn-group-toggle m-1">
                                        <label id="btn_filters_sent" class="btn sharp btn-outline-dark btn-sm btn-block" style="min-width: 150px;"
                                            [ngClass]="{active: sentFilter}">
                                            <input type="checkbox" (click)="sentFilterClick();">
                                            {{ 'main.filters.sent' | translate }}
                                        </label>
                                    </div>
                                </ng-container>

                                <ng-container *ngFor="let tableConfig of tableConfigs$ | async">
                                    <ng-container
                                    *ngIf="tableConfig.contentType === 'string' && tableConfig.active === true && tableConfig.headerContent === true && tableConfig.idParam === 22">
                                    <div class="btn-group-toggle m-1">
                                        <label id="btn_filters_container_no_data" class="btn sharp btn-outline-dark btn-sm btn-block" style="min-width: 150px;"
                                            [ngClass]="{active: containerNoData}">
                                            <input type="checkbox" (click)="cointainerNoDataFilter();">
                                            {{ 'main.filters.container-no-data' | translate }}
                                        </label>
                                    </div>
                                </ng-container>
                                </ng-container>



                            </div>
                        </div>
                        &nbsp;
                        <div class="btn-group-toggle" style="border: 1px solid black;">
                            <label id="btn_remove_filters" class="btn sharp" placement="center"
                                [ngStyle]="{'background-color': checkFilters() ? '#bb3332' : '', 'color': '#ffffff'}">
                                <input type="checkbox" (click)="cleanFilters();">
                                <img style="width: 20px; height:20px;"
                                    [src]="checkFilters() ? '../../../assets/icons/icons8-eliminar-filtros-50-blanco.png' : '../../../assets/icons/icons8-eliminar-filtros-50.png'">
                            </label>
                        </div>
                    </div>

                </div>
            </div>

            

            <ngb-alert #selfClosingErrorAlert *ngIf="errorMessage" type="danger" (closed)="errorMessage = ''" style="position: fixed; top:10%; left: 50%; z-index: 9999;">{{
                errorMessage }}
            </ngb-alert>

            <ngb-alert #selfClosingOKAlert *ngIf="okMessage" type="success" (closed)="okMessage = ''" style="position: fixed; top:10%; left: 50%; z-index: 9999;">{{ okMessage }}
            </ngb-alert>

            <div class="row flex-grow-1">
                <div class="col-lg d-flex flex-column justify-content-between">
                    <div class="row" style="border: 3px outset #000; ">
                        <table class="table table-responsive-lg">
                            <thead style="background-color: #808080;">
                                <tr>
                                    <ng-container *ngFor="let tableConfig of tableConfigs$ | async">
                                        <ng-container
                                            *ngIf="tableConfig.contentType === 'string' && tableConfig.active === true">
                                            <th id="table_header_{{tableConfig.headerContent}}" class="text-center align-middle" style="color: white;" scope="col">
                                                <p class="m-0">{{tableConfig.headerContent}}</p>
                                            </th>
                                        </ng-container>
                                        <ng-container
                                            *ngIf="tableConfig.contentType === 'array_string' && tableConfig.active === true">
                                            <th id="{{service.setTableHeaderId(tableConfig)}}" class="text-center" style="color: white;" scope="col">
                                                <p class="m-0" *ngFor="let item of tableConfig.headerContent">
                                                    {{item.value}}
                                                </p>
                                            </th>
                                        </ng-container>
                                        <ng-container
                                            *ngIf="tableConfig.contentType === 'image' && tableConfig.active === true">
                                            <th id="{{service.setTableHeaderId(tableConfig)}}" class="text-center align-middle" style="color: white;" scope="col">
                                                <img src="{{tableConfig.headerContent}}"
                                                    style="width: 24px; height:24px;">
                                            </th>
                                        </ng-container>
                                    </ng-container>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngFor="let wdtkevent of events$ | async">
                                    
                                    <tr [style.backgroundColor]="service.colors(wdtkevent)"
                                        [style.border]="service.selectedBorder(wdtkevent)"
                                        (click)="eventSelected($event, wdtkevent)">
                                        <ng-container *ngFor="let eventDetail of wdtkevent.params">
                                            <ng-container
                                                *ngIf="eventDetail.contentType === 'string' || eventDetail.contentType === 'array_string'">
                                                <td id= "{{eventDetail.valueData}}" class="text-center align-middle" style="color: black;" scope="col">
                                                    <p class="m-0">{{eventDetail.valueData}}</p>
                                                </td>
                                            </ng-container>
                                            <ng-container
                                                *ngIf="eventDetail.contentType === 'image' && eventDetail.param === 'plate_image_url'">
                                                <td id="img_photo" class="text-center align-middle" style="color: black;" scope="col">
                                                    <img src="../../../assets/icons/icons8_Camera_Identification_black_24px.png"
                                                        style="width: 20px; height:20px;"
                                                        (click)="showImage($event, eventDetail.valueData);">
                                                </td>
                                            </ng-container>
                                            <ng-container
                                                *ngIf="eventDetail.contentType === 'image' && eventDetail.param === 'truck_image_url'">
                                                <td id="img_scan" class="text-center align-middle" style="color: black;" scope="col">
                                                    <img src="../../../assets/icons/icons8_Truck_black_24px_2.png"
                                                        style="width: 20px; height:20px;"
                                                        (click)="showImage($event, eventDetail.valueData);">
                                                </td>
                                            </ng-container>
                                            <ng-container
                                            *ngIf="eventDetail.contentType === 'image' && eventDetail.param === 'last_state'">
                                            <td id= "{{eventDetail.valueData}}" class="text-center align-middle" style="color: black;" scope="col" data-toggle="tooltip" title="{{service.setSatusText(eventDetail.valueData) | translate}}">
                                                <img src="{{service.setStatusIcon(eventDetail.valueData)}}"
                                                    style="width: 25px; height:25px;">
                                            </td>
                                        </ng-container>

                                        </ng-container>
                                    </tr>
                                </ng-container>
                            </tbody>
                        </table>
                    </div>

                    <!-- paginador -->
                    <div class="row d-flex justify-content-between p-2"
                        style="border: 3px outset #000; background-color: #808080;">


                        <ngb-pagination [collectionSize]="(collectionSize$ | async)!" [(page)]="service.page"
                            [pageSize]="service.pageSize" [maxSize]="10" [rotate]="true" [ellipses]="false"
                            [boundaryLinks]="true">
                        </ngb-pagination>

                        <select id="slct_pages" class="form-select sharp" style="width: auto" name="pageSize"
                            [(ngModel)]="service.pageSize">
                            <option [ngValue]="10">{{ 'main.paginator.ten-items' | translate }}</option>
                            <option [ngValue]="25">{{ 'main.paginator.twenty-five-items' | translate }}</option>
                            <option [ngValue]="50">{{ 'main.paginator.fifty-items' | translate }}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>